//# sourceMappingURL=numbering.mjs.map
/// <reference types="./numbering.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class FullNumberingProps extends $CustomType {
  constructor(num_id, level, abstract_num_id, format) {
    super();
    this.num_id = num_id;
    this.level = level;
    this.abstract_num_id = abstract_num_id;
    this.format = format;
  }
}
export const NumberingProps$FullNumberingProps = (num_id, level, abstract_num_id, format) =>
  new FullNumberingProps(num_id, level, abstract_num_id, format);
export const NumberingProps$isFullNumberingProps = (value) =>
  value instanceof FullNumberingProps;
export const NumberingProps$FullNumberingProps$num_id = (value) => value.num_id;
export const NumberingProps$FullNumberingProps$0 = (value) => value.num_id;
export const NumberingProps$FullNumberingProps$level = (value) => value.level;
export const NumberingProps$FullNumberingProps$1 = (value) => value.level;
export const NumberingProps$FullNumberingProps$abstract_num_id = (value) =>
  value.abstract_num_id;
export const NumberingProps$FullNumberingProps$2 = (value) =>
  value.abstract_num_id;
export const NumberingProps$FullNumberingProps$format = (value) => value.format;
export const NumberingProps$FullNumberingProps$3 = (value) => value.format;

export class EditorNumberingProps extends $CustomType {
  constructor(format) {
    super();
    this.format = format;
  }
}
export const NumberingProps$EditorNumberingProps = (format) =>
  new EditorNumberingProps(format);
export const NumberingProps$isEditorNumberingProps = (value) =>
  value instanceof EditorNumberingProps;
export const NumberingProps$EditorNumberingProps$format = (value) =>
  value.format;
export const NumberingProps$EditorNumberingProps$0 = (value) => value.format;

export function decoder() {
  return $decrypt.optional_field(
    "num_id",
    $decode.int,
    (num_id) => {
      if (num_id instanceof Some) {
        let num_id$1 = num_id[0];
        return $decode.field(
          "level",
          $decode.int,
          (level) => {
            return $decode.field(
              "abstract_num_id",
              $decode.int,
              (abstract_num_id) => {
                return $decode.field(
                  "format",
                  $decode.string,
                  (format) => {
                    return $decode.success(
                      new FullNumberingProps(
                        num_id$1,
                        level,
                        abstract_num_id,
                        format,
                      ),
                    );
                  },
                );
              },
            );
          },
        );
      } else {
        return $decode.field(
          "format",
          $decode.string,
          (format) => {
            return $decode.success(new EditorNumberingProps(format));
          },
        );
      }
    },
  );
}

export function encode(props) {
  if (props instanceof FullNumberingProps) {
    let num_id = props.num_id;
    let level = props.level;
    let abstract_num_id = props.abstract_num_id;
    let format = props.format;
    return $json.object(
      toList([
        ["num_id", $json.int(num_id)],
        ["level", $json.int(level)],
        ["abstract_num_id", $json.int(abstract_num_id)],
        ["format", $json.string(format)],
      ]),
    );
  } else {
    let format = props.format;
    return $json.object(toList([["format", $json.string(format)]]));
  }
}
